<template>
    <div class="default-page">

        <div class="block">
            <div class="title">How did you hear?</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table-scroll">
                        <thead>
                            <tr>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            Parameter
                                        </div>
                                    </div>
                                </th>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            Count
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result">
                                <td class="text-left">{{ item.title }}</td>
                                <td class="text-left">{{ item.total }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">"Other" options {{ other.count }} item(s)</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table-scroll">
                        <thead>
                            <tr>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            #
                                        </div>
                                    </div>
                                </th>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            Value
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in other.variables">
                                <td class="">{{ index + 1 }}</td>
                                <td class="text-left wrap">{{ item }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">"ANYTHING ELSE WE SHOULD KNOW?" options ({{ additional.count }} item(s))</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table-scroll">
                        <thead>
                            <tr>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            #
                                        </div>
                                    </div>
                                </th>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            Value
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in additional.variables">
                                <td class="">{{ index + 1 }}</td>
                                <td class="text-left wrap">{{ item }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


        <div class="block">
            <div class="title">Members ({{ users.length }} items)</div>
            <div class="body">
                <div class="table-scroll__wrapper">
                    <table class="table-scroll">
                        <thead>
                            <tr>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            #
                                        </div>
                                    </div>
                                </th>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            ID
                                        </div>
                                    </div>
                                </th>

                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            Name
                                        </div>
                                    </div>
                                </th>

                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            Member
                                        </div>
                                    </div>
                                </th>
                                <th colspan="1" class="">
                                    <div :class="['table__title']">
                                        <div class="label">
                                            Active Membership
                                        </div>
                                    </div>
                                </th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in users">
                                <td class="">{{ index + 1 }}</td>
                                <template v-if="item">
                                    <td class="">
                                        <router-link class="link"
                                                     target="_blank"
                                                     :to="{name: 'user.edit', params: { id: item.id }}">
                                            ID{{ item.id }}
                                        </router-link>
                                    </td>
                                    <td class="text-left wrap">@{{ item.name }}</td>
                                    <td class="text-left wrap">{{ item.first_name }} {{ item.last_name }}</td>
                                    <td class="text-left wrap">{{ item.subscribe_original ? item.subscribe_original.plan.title : '-' }}</td>
                                </template>
                                <template v-else>
                                    <td class="">
                                           ##
                                    </td>
                                    <td class="text-left wrap">Deleted user</td>
                                    <td class="text-left wrap">-</td>
                                    <td class="text-left wrap">-</td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>


    </div>
</template>

<script>


import Table from "../Utils/Table/Table.vue";

export default {
    name: "HowKnow",
    components: {Table},
    data() {
        return {
            result: [],
            other: {
                count: 0,
                variables: []
            },
            additional: {
                count: 0,
                variables: []
            },
            users: [],
        }
    },
    mounted() {
        this.$store.commit('setDashboardTitle', 'How did you hear?')
        axios
            .post(this.$store.getters.getApiUrl('user.how_know'))
            .then(({data}) => {
                if (data.result) {
                    this.result = data.result
                }
                if (data.other) {
                    this.other = data.other
                }
                if (data.users) {
                    this.users = data.users
                }
                if (data.additional) {
                    this.additional = data.additional
                }
            })
    },
    methods: {

    }
}
</script>

<style scoped>

</style>
